export const RELATION_PATH = {
  livestock: 'animals',
  pasture: 'pastures',
  farm: 'farms',
  site: 'sites',
  group: 'group'
};
